// import {useLayoutEffect, useRef} from 'react'
// import { Datepicker } from 'vanillajs-datepicker';
// import { Form } from 'react-bootstrap';

// function DatePicker({className, value, id, ...props}) {
//     const {autoHide, clearBtn, format, maxView, pickLevel, startView, title, todayBtn, weekStart} = props;
//     const dateInput = useRef(null);

//     useLayoutEffect( ()=> {
//       let opt = {
//         title: title || '',
//         buttonClass: 'btn btn-md',
//         autohide: autoHide || true,
//         clearBtn: clearBtn || false,
//         todayBtn: todayBtn || false,
//         format: format || 'yyyy-mm-dd',
//         maxView: maxView || 3,
//         pickLevel: pickLevel || 0,
//         startView: startView || 0,
//         weekStart: weekStart || 0
//       };
//       new Datepicker(dateInput.current, opt);

//     })

//   return (
//     <>
//       <Form.Control className={className} defaultValue={value} ref={dateInput} value={value} id={id} placeholder="yyyy-mm-dd" autoComplete="off"/> 
//     </>
//   )
// }

// export default DatePicker

import { useLayoutEffect, useRef } from 'react';
import { Datepicker } from 'vanillajs-datepicker';
// import 'vanillajs-datepicker/dist/css/datepicker.css';
import { Form } from 'react-bootstrap';

function DatePicker({ className, value, id, onChange, ...props }) {
  const { autoHide, clearBtn, format, maxView, pickLevel, startView, title, todayBtn, weekStart } = props;
  const dateInput = useRef(null);
  const datepickerInstance = useRef(null);
  const changeHandlerRef = useRef(null);

  useLayoutEffect(() => {
    if (!dateInput.current) return;

    const opt = {
      title: title || '',
      buttonClass: 'btn btn-md',
      autohide: autoHide ?? true,
      clearBtn: clearBtn ?? false,
      todayBtn: todayBtn ?? false,
      format: format || 'yyyy-mm-dd',
      maxView: maxView || 3,
      pickLevel: pickLevel || 0,
      startView: startView || 0,
      weekStart: weekStart || 0,
    };

    // Initialize the date picker
    datepickerInstance.current = new Datepicker(dateInput.current, opt);

    // When date changes, trigger React's onChange
    changeHandlerRef.current = (e) => {
      if (onChange) {
        const newDate = e.detail?.date;
        if (!newDate) {
          onChange('');
          return;
        }
        const formattedDate = newDate.toISOString().substring(0, 10);
        onChange({ target: { value: formattedDate } });
      }
    };
    dateInput.current.addEventListener('changeDate', changeHandlerRef.current);

    return () => {
      if (dateInput.current && changeHandlerRef.current) {
        dateInput.current.removeEventListener('changeDate', changeHandlerRef.current);
      }
      datepickerInstance.current?.destroy?.();
    };
  }, [autoHide, clearBtn, format, maxView, onChange, pickLevel, startView, title, todayBtn, weekStart]);

  useLayoutEffect(() => {
    if (!dateInput.current) return;
    const normalizedValue = value || '';
    if (dateInput.current.value !== normalizedValue) {
      dateInput.current.value = normalizedValue;
    }
  }, [value]);

  return (
    <Form.Control
      className={className}
      id={id}
      ref={dateInput}
      defaultValue={value || ''}
      autoComplete="off"
    />
  );
}

export default DatePicker;
